<!-- Объекты низ -->
<div class="tabpage objects" id="objects_bottom">
  <app-device-info-menu [mapMode]="true"></app-device-info-menu>
  <div class="tablewrap">
    <div class="table">
      <table id="pointinfotable">
        <tr>
          <td class="caption" colspan="4">
            <img id="markericon" />
            <div>
              <span id="markername"></span>
              <span id="markercomment"></span>
            </div>
          </td>
        </tr>
        <tr><td colspan="2">{{'Time'|translate }}</td><td colspan="2"><span id="markertime"></span></td></tr>
        <tr *ngIf="trackingMode"><td colspan="2">{{'Address'|translate }}</td><td colspan="2"><span id="markeraddr"></span></td></tr>
        <tr><td colspan="2">{{'Coordinates'|translate }}</td><td colspan="2"><span id="markercoord"></span></td></tr>
        <tr><td colspan="2">{{'Speed'|translate }}</td><td colspan="2"><span id="markerspeed"></span></td></tr>
        <tr><td colspan="2">{{'Satellites'|translate }}</td><td colspan="2"><span id="markersat"></span></td></tr>
      </table>
    </div>
  </div>
</div>
